import { ArrowRightCircleIcon } from "@heroicons/react/24/outline";
import SearchBar from "../../Input/components/SearchBar";
import { useFormik } from "formik";
import { useQuery } from "@apollo/client";
import { FETCH_SUPPORT_ARTICLES } from "../../../../graphql/query/SupportArticle";
import { Pagination, Spinner } from "../../";
import { useLocation } from "react-router-dom";
import { ROOT_VERSION } from "../../../../generated/rootVersion";

const ArticleContent = props => {
  const { meta } = props || {};
  const { title, module, summary, documentLink } = meta || {};

  const buildUrl = () => {
    if (documentLink?.includes("http")) {
      return documentLink;
    } else {
      return `//${documentLink}`;
    }
  };

  return (
    <div
      className="mb-8 cursor-pointer"
      onClick={() => documentLink && window.open(buildUrl(), "_blank")}
    >
      <div className="text-lg font-bold">{title}</div>
      <div className="overflow mb-2">{summary}</div>
      <div className="text-xs font-bold">MODULE: {module}</div>
    </div>
  );
};

const FormLoggingSupport = props => {
  const { nextStep, position = "bottom-left" } = props || {};
  const LIMIT = 3;
  const rootVersion = ROOT_VERSION;
  const location = useLocation();

  const formik = useFormik({
    initialValues: {
      limit: LIMIT,
      offset: 0,
      search: "",
    },
  });

  const {
    data: { supportArticles: { count, edges = [] } = {} } = {},
    loading,
  } = useQuery(FETCH_SUPPORT_ARTICLES, {
    variables: {
      input: {
        limit: formik?.values.limit,
        page: location?.pathname,
        offset: formik?.values.offset,
        search: formik?.values.search,
      },
    },
  });

  const searchBarProps = {
    formik,
    name: "search",
  };

  const onChange = values => {
    formik?.setValues({ ...formik?.values, ...values });
  };

  const paginationProps = {
    count,
    limit: formik?.values?.limit,
    offset: formik?.values?.offset,
    onChange,
    variant: "xs",
    customPageRange: 2,
  };

  return (
    <div
      className={`absolute z-[30] max-h-[calc(100vh-2rem)] w-[486px] flex flex-col rounded border border-gray-300 bg-white px-6 py-4 shadow-lg ${
        position === "top-right"
          ? "right-4 top-16"
          : "bottom-4 left-16"
      }`}
    >
      <div className="fontbold mb-4 text-lg font-bold">Support</div>
      <div className="pb-4">
        <SearchBar {...searchBarProps} />
      </div>
      <div className="flex flex-1 min-h-0 flex-col overflow-y-auto">
        {loading ? (
          <div className="flex w-full items-center justify-center">
            <Spinner />
          </div>
        ) : (
          edges?.map((item, index) => {
            return <ArticleContent key={index} {...item} />;
          })
        )}
      </div>
      <div className="flex-shrink-0 pt-4">
        <Pagination {...paginationProps} />
        <div className="flex items-center justify-between pb-2 pt-3">
          <div onClick={nextStep} className="cursor-pointer inline-flex items-center text-sm font-bold">
            Can`t find a helpful article? Submit a Ticket
            <ArrowRightCircleIcon
              className="ml-2 h-4 w-4 inline-block"
            />
          </div>
          {rootVersion && (
            <div className="text-xs text-gray-500">
              v{rootVersion}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default FormLoggingSupport;
